import React from 'react';
import {
  IconCalendar,
  IconCalendarOff,
  IconChevronLeft,
  IconChevronRight,
  IconPlus,
} from '@tabler/icons-react';
import {
  SecondaryToolbar,
  ToolbarButton,
  ToolbarRadio,
  ToolbarSpacer,
} from '../toolbar';
import { CalendarViewMode } from './calendarTypes';
import './CalendarToolbar.css';

interface CalendarToolbarProps {
  viewMode: CalendarViewMode;
  dateLabel: string;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
  onViewModeChange: (mode: CalendarViewMode) => void;
  onAddAppointment: () => void;
  onAddLeave: () => void;
}

/**
 * Calendar contextual toolbar — built from the shared SecondaryToolbar control
 * kit so it reads identically to every other page's toolbar (44px controls,
 * floating-card shell, the standard card shadow).
 */
export const CalendarToolbar: React.FC<CalendarToolbarProps> = ({
  viewMode,
  dateLabel,
  onPrev,
  onNext,
  onToday,
  onViewModeChange,
  onAddAppointment,
  onAddLeave,
}) => {
  return (
    <SecondaryToolbar floating>
      <ToolbarButton icon={IconCalendar} onClick={onToday}>
        Today
      </ToolbarButton>
      <ToolbarButton icon={IconChevronLeft} onClick={onPrev} title="Previous">
        {''}
      </ToolbarButton>
      <ToolbarButton icon={IconChevronRight} onClick={onNext} title="Next">
        {''}
      </ToolbarButton>
      <span className="cal-toolbar-range">{dateLabel}</span>

      <ToolbarRadio
        name="calendar-view"
        label="Week"
        active={viewMode === 'week'}
        onClick={() => onViewModeChange('week')}
      />
      <ToolbarRadio
        name="calendar-view"
        label="Day"
        active={viewMode === 'day'}
        onClick={() => onViewModeChange('day')}
      />

      <ToolbarSpacer />

      <ToolbarButton variant="primary" icon={IconPlus} onClick={onAddAppointment}>
        Add Appointment
      </ToolbarButton>
      <ToolbarButton icon={IconCalendarOff} onClick={onAddLeave}>
        Add Leave
      </ToolbarButton>
    </SecondaryToolbar>
  );
};
